/** @jsxImportSource @emotion/react */
"use client";

import * as AccordionPrimitive from "@radix-ui/react-accordion";

import type { ThemeType } from "../../../../../global/emotion";
import { fontSizes, lineHeights, spacing } from "../../../../../global/emotion";

const contentStyle = (theme: ThemeType) => ({
  color: theme.semanticColors.neutralsMedium,
  fontSize: fontSizes.bodyM,
  lineHeight: lineHeights.bodyM,
  overflow: "hidden",
  paddingInline: spacing.s,
});

export function AccordionContent({
  children,
  ...props
}: React.ComponentProps<typeof AccordionPrimitive.Content>) {
  return (
    <AccordionPrimitive.Content css={contentStyle} {...props}>
      {children}
    </AccordionPrimitive.Content>
  );
}
